"use client"

import React from "react"
import { FilterButton, Text } from "@/elements"
import { MagnifyingGlassIcon, PencilSquareIcon } from "@heroicons/react/24/outline"
import { IconButton } from "@/elements"
import { useMessages } from "./hooks/useMessages"

type Props = {
  filters: any[]
  onClickFilter: (filter: string) => void
  searchQuery: string
  onChangeSearch: (search: string) => void
  activeFilter: string
}

export const MessagingChannelListHeader: React.FC<Props> = ({
  filters,
  onClickFilter,
  searchQuery,
  onChangeSearch,
  activeFilter,
}) => {
  const { toggleMobileChannel, setIsCreating, isCreating } = useMessages()

  const handleCreateChannel = () => {
    if (!isCreating) {
      toggleMobileChannel()
    }
    setIsCreating(!isCreating)
  }

  return (
    <div>
      <div className="flex h-[90px] flex-row items-center justify-between border-b border-bg-3 px-6">
        <Text variant="h5">Messages</Text>
        <IconButton onClick={handleCreateChannel} Icon={PencilSquareIcon} />
      </div>
      <div className="mt-4 px-6">
        <div className="flex w-full flex-row items-center rounded-full bg-bg-2 px-3 py-2">
          <div className="flex flex-shrink-0 pr-2">
            <MagnifyingGlassIcon height={22} className="text-fg-1" />
          </div>
          <input
            placeholder="Search"
            type="search"
            value={searchQuery}
            onChange={e => onChangeSearch(e.target.value)}
            className="w-full border-none bg-transparent p-0 focus:outline-none focus:ring-0"
          />
        </div>
        <div className="my-4 flex flex-row items-center gap-2">
          {filters.map(({ label, value }) => {
            const active = activeFilter === value
            return (
              <FilterButton
                size="sm"
                key={value}
                onClick={() => onClickFilter(value)}
                hasDropdown={false}
                label={label}
                active={active}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}
